import script from "./RoomItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoomItem.vue?vue&type=script&lang=ts&setup=true"

import "./RoomItem.vue?vue&type=style&index=0&id=3123f40d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3123f40d"]])

export default __exports__